import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type { ITransferPricingDocumentationDetailsResponse } from './types';

export const useTransferPricingDocumentationDetails = (
  documentationId: string | null
) => {
  const { data, error, isLoading } =
    useSWR<ITransferPricingDocumentationDetailsResponse>(
      documentationId
        ? TransferPricingDocumentationRequestHelper.detailsPath(documentationId)
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return { details: data?.details ?? null, isLoading, error };
};
